import React, { useState } from 'react';
import SecondaryHeader from '../header/SecondaryHeader';
import { PrimaryHeader } from '../header/PrimaryHeader';
import FeedbackBlock from '../blocks/FeedbackBlock';

export interface MainLayoutProps {
    children: React.ReactNode;
}

export const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const closeMobileMenu = () => {
        setIsMobileMenuOpen(false);
    };

    return (
        <div className="page">
            <div
                className={`mobile-menu-overlay ${isMobileMenuOpen ? 'visible' : ''}`}
                onClick={closeMobileMenu}
            ></div>
            <SecondaryHeader
                isMobileMenuOpen={isMobileMenuOpen}
                closeMobileMenu={closeMobileMenu}
            />
            <div className="page-content">
                <PrimaryHeader
                    toggleMobileMenu={toggleMobileMenu}
                />
                <div className="page-content-inner">
                    {children}
                </div>
            </div>
            <FeedbackBlock />
        </div>
    );
};
